var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 20.125V19.3398C23.25 15.4383 26.256 12.25 30 12.25C33.744 12.25 36.75 15.4383 36.75 19.3398V20.1272H41.358C41.6367 20.1275 41.9054 20.2312 42.112 20.4183C42.3186 20.6054 42.4484 20.8624 42.4762 21.1398L44.5012 41.3898C44.517 41.5461 44.4997 41.704 44.4507 41.8533C44.4017 42.0026 44.3219 42.1399 44.2166 42.2565C44.1112 42.3731 43.9826 42.4663 43.8391 42.5302C43.6955 42.594 43.5401 42.6271 43.383 42.6273H16.617C16.4599 42.6271 16.3045 42.594 16.1609 42.5302C16.0174 42.4663 15.8888 42.3731 15.7834 42.2565C15.6781 42.1399 15.5983 42.0026 15.5493 41.8533C15.5002 41.704 15.483 41.5461 15.4987 41.3898L17.5237 21.1398C17.5516 20.8624 17.6814 20.6054 17.888 20.4183C18.0946 20.2312 18.3633 20.1275 18.642 20.1272H23.25V20.125ZM25.5 20.125H34.5V19.3398C34.5 16.6533 32.4705 14.5 30 14.5C27.5295 14.5 25.5 16.6533 25.5 19.3398V20.1272V20.125ZM23.25 22.375H19.6612L17.8612 40.375H42.1387L40.3365 22.375H36.75V25.75C36.75 26.0484 36.6315 26.3345 36.4205 26.5455C36.2095 26.7565 35.9234 26.875 35.625 26.875C35.3266 26.875 35.0405 26.7565 34.8295 26.5455C34.6185 26.3345 34.5 26.0484 34.5 25.75V22.375H25.5V25.75C25.5 26.0484 25.3815 26.3345 25.1705 26.5455C24.9595 26.7565 24.6734 26.875 24.375 26.875C24.0766 26.875 23.7905 26.7565 23.5795 26.5455C23.3685 26.3345 23.25 26.0484 23.25 25.75V22.375Z",
    fill: "#179CF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.5,
    stroke: "#179CF0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.bb25488c7ce4b8e3a61da4ba493ec87b.svg";
export { ForwardRef as ReactComponent };